import { Archetype, quizQuestions } from '../data/quizData';

export interface QuizAnswer {
  questionId: number;
  answer: number; // Index of selected option (0-5)
}

export interface ArchetypeScore {
  archetype: Archetype;
  value: number; // 0-100
}

export function calculateScores(answers: QuizAnswer[]): ArchetypeScore[] {
  // Initialize scores for each archetype
  const archetypeCounts: Record<Archetype, number> = {
    Vishnu: 0,
    Lakshmi: 0,
    Ketu: 0,
    Rahu: 0,
    Alakshmi: 0,
    Eris: 0
  };

  // Count selections for each archetype
  answers.forEach(answer => {
    const question = quizQuestions.find(q => q.id === answer.questionId);
    if (question) {
      const selectedOption = question.options[answer.answer];
      archetypeCounts[selectedOption.archetype]++;
    }
  });

  // Convert counts to percentages (0-100)
  const totalQuestions = answers.length;
  const scores: ArchetypeScore[] = Object.entries(archetypeCounts).map(([archetype, count]) => ({
    archetype: archetype as Archetype,
    value: Math.round((count / totalQuestions) * 100)
  }));

  // Sort by score (highest first)
  return scores.sort((a, b) => b.value - a.value);
}

// Helper function to get the dominant archetype
export function getDominantArchetype(scores: ArchetypeScore[]): Archetype {
  return scores[0]?.archetype || 'Vishnu'; // Default to Vishnu if no scores
}

// Helper function to get the secondary archetype
export function getSecondaryArchetype(scores: ArchetypeScore[]): Archetype {
  return scores[1]?.archetype || 'Sage';
} 